import styles from "./components/ApplicationTemplateCategory/ApplicationTemplateCategory.module.scss"
import { TemplateVersionStatus } from "../../models/workshop/common"

export const WORKSHOP_CONST = {
    tNamespace: "workshop",
    tPaths: {
        chooseTemplates: "choose-templates",
        noTemplates: "no-templates",
        templatesList: "templates-list",
        noMatches: "no-matches",
        title: "title",
        modal: {
            delete: {
                versionHeader: "form.modal.delete.version-header",
                versionMessage: "form.modal.delete.version-message",
                templateHeader: "form.modal.delete.template-header",
                templateMessage: "form.modal.delete.template-message",
                publishedExistWarningHeader: "form.modal.delete.published-exist-warning-header",
                publishedExistWarningMessage: "form.modal.delete.published-exist-warning-message"
            },
            cancel: "form.modal.cancel",
            deleteText: "form.modal.delete-text"
        },
        deleteVersion: "templates-list.delete-version",
        deleteTemplate: "templates-list.delete-template",
        updateApplicationAvailable: "update-application-available"
    }
}

export const classByStatus: Record<TemplateVersionStatus, string> = {
    [TemplateVersionStatus.RELEASE]: styles.category__status_published,
    [TemplateVersionStatus.PUBLISH]: styles.category__status_published,
    [TemplateVersionStatus.DRAFT]: styles.category__status_draft,
    [TemplateVersionStatus.REVIEW]: styles.category__status_draft,
    [TemplateVersionStatus.UNPUBLISH]: styles.category__status_unpublished
}

export const applicationPrefix = "APPLICATION_ENTITY"
